import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { loadBanner, updateBanner, clearBanner } from '../../actions/banner'
import { notificate } from '../../actions/notification'
import { BannerForm, Spinner } from '../'
import { bannerValidator } from '../../validators'
import { links } from '../../utils'

class BannerEdit extends Component {
  state = {
    errors: {}
  };

  componentDidMount () {
    this._loadData()
  };

  componentDidUpdate () {
    const { redirect } = this.props.banner
    if (redirect) {
      return this.props.history.push(redirect)
    }
  };

  render () {
    const { errors } = this.state
    const { banner, sending } = this.props.banner
    const hasBanner = banner && banner.id

    return (
      <div className="main-content">
        <header className="main-content__header">
          <h1 className="main-content__title">Adicionar banner</h1>
          <Link to={links.get('banners')} className="main-content__cancel">Voltar</Link>
        </header>
        {sending && !hasBanner &&
          <div className="spinner-box">
            <Spinner />
          </div>
        }
        {hasBanner &&
          <BannerForm
            sending={sending}
            editBanner={banner}
            errors={errors}
            onSubmit={this._handleSubmit}
          />
        }
      </div>
    )
  };

  _loadData = () => {
    const { token } = this.props
    const id = this.props.history.location.pathname.split('/').pop()
    this.props.clearBanner()
    this.props.loadBanner(id, token)
  };

  _handleSubmit = data => {
    const errors = {}
    this.setState({ errors }, () => {
      bannerValidator.update(data).then(result => {
        if (result.success) {
          const { token } = this.props
          this.props.updateBanner(data, token)
        } else {
          this.setState({ errors: result.errors })
        }
      }).catch(error => {
        this.props.notificate(error.message)
      })
    })
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.user.user.token,
    banner: state.banner
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadBanner: (id, token) => dispatch(loadBanner(id, token)),
    updateBanner: (data, token) => dispatch(updateBanner(data, token)),
    clearBanner: () => dispatch(clearBanner()),
    notificate: message => dispatch(notificate(message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BannerEdit)
